// Role → landing route resolver for Phase 7 dedicated shells.
// Reused by Login redirect + Layout brand-mark click.

export function roleHome(role) {
  switch (role) {
    case "court_umpire":
      return "/referee";
    case "owner":
      return "/my-team";
    case "spectator":
      return "/player";
    case "super_admin":
    case "league_admin":
    default:
      return "/dashboard";
  }
}
